module.exports = __webpack_public_path__ + "img/close.822d3a82.svg";